<template>
  <div class="upload-document-page row justify-center items-center">
    <q-dialog v-model="importFailed">
      <q-card class="error-card">
        <q-card-section class="row items-center q-pb-none error-card-header">
          <div class="text-h6">Importeren mislukt</div>
          <q-space />
          <q-btn icon="close" flat round dense v-close-popup />
        </q-card-section>
        <q-card-section>
          <div class="text-subtitle1">
            {{ importFailedTitle }}
          </div>
        </q-card-section>
        <q-card-section>
          <div v-if="importRowsFailed">
            <a :href="importFailedMsg" download
              >Download Excel-bestand met onjuiste records</a
            >
          </div>
          <div v-else class="text-italic">
            {{ importFailedMsg }}
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <q-uploader
      label="Document uploaden"
      color="primary"
      :multiple="false"
      :auto-upload="true"
      accept=".xlsm, .xlsx, .xls"
      :factory="factoryFn"
      @failed="failedFn"
      @added="addedFn"
    />
  </div>
</template>
<script>
import axiosUrl from "../services/axios.service";
import router from "../router";
const API_URL = axiosUrl.getAxiosUrl();
import store from "../store/index.js";
import axios from "axios";

export default {
  data() {
    return {
      importFailed: false,
      importRowsFailed: false,
      importFailedTitle: "",
      importFailedMsg: "",
    };
  },
  mounted() {
    let user = store.state.auth.authUser;
    if (!user.hasFomoManagementPermission) {
      router.push("/");
    }
  },
  methods: {
    factoryFn(files) {
      return new Promise((resolve, reject) => {
        const formData = new FormData();
        formData.append("file", files[0]);

        axios
          .post(`${API_URL}/import/upload`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            resolve({
              success: true,
              status: response.status,
              xhr: {
                response: JSON.stringify(response.data),
              },
            });
          })
          .catch((error) => {
            reject({
              success: false,
              status: error.response?.status || 500,
              xhr: {
                response: JSON.stringify(
                  error.response?.data || { error: "Upload failed" }
                ),
              },
            });
          });
      });
    },

    failedFn(info) {
      var responseBody = JSON.parse(info.xhr.response);
      var errorType = responseBody["error"];
      var errorMsg = responseBody["errorMsg"];
      this.importFailed = true;

      if (errorType == "RowsValidationFailed") {
        this.importRowsFailed = true;
        this.importFailedTitle = errorMsg["title"];
        this.importFailedMsg =
          API_URL + `/import/download?fileName=` + errorMsg["body"];
      } else {
        this.importFailedTitle = errorMsg["title"];
        this.importFailedMsg = errorMsg["body"];
      }
    },

    addedFn() {
      this.importFailed = false;
      this.importRowsFailed = false;
    },
  },
};
</script>
